import RouteConstants from '@/features/router/RouteConstants';
import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import { Button } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LuLink } from 'react-icons/lu';
import { BarChartHeaderIcon } from '../PlatformBrandIcons';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'performanceAudience:page.title',
    path: RouteConstants.performanceAudience,
  },
];

type PerformanceAudiencePageHeaderProps = {
  onExport?: () => void;
};

export const PerformanceAudiencePageHeader: FC<PerformanceAudiencePageHeaderProps> = ({ onExport }) => {
  const { t } = useTranslation('performanceAudience');

  return (
    <header className='grid gap-4'>
      <Breadcrumbs items={breadcrumbs} />
      <div className='flex flex-wrap items-center justify-between gap-4'>
        <div className='flex items-center gap-2.5'>
          <BarChartHeaderIcon />
          <h1 className='text-2xl font-semibold text-primary-900'>{t('page.title')}</h1>
        </div>
        <Button intent='secondary' size='md' onClick={onExport} className='inline-flex items-center gap-2'>
          <LuLink className='size-4' aria-hidden />
          {t('page.export')}
        </Button>
      </div>
    </header>
  );
};
